import { Button } from '@app/components/various/Button';
import { Filters as FiltersIcon } from '@app/components/various/Icons';
import { ShareButton } from '@app/components/various/ShareButton';
import { BREAKPOINTS } from '@app/constants/breakpoints';
import { useIsScreenSize } from '@app/utils/hooks';
import { isDefined } from '@app/utils/is';
import { Filter as FilterNS, ProductFilters } from '@typings';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AppliedFilters } from '../FiltersBar/AppliedFilters';

interface Props {
  filters: ProductFilters;
  attributes: FilterNS.Field<string>[];
  shareUrl?: string;
  actions?: React.ReactNode;
  onFiltersOpen: () => void;
  isLoading: boolean;
  onFilterChange: (newFilters: ProductFilters) => void;
}

export const ProductsListingHeading = ({
  filters,
  attributes,
  shareUrl,
  children,
  onFiltersOpen,
  onFilterChange,
  isLoading,
}: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation(['products', 'common']);
  const isMobile = useIsScreenSize(BREAKPOINTS.SM);

  return (
    <div className="flex items-center justify-between gap-1 pb-2 pl-4 sm:h-16">
      <div className="flex w-full flex-col gap-4 sm:gap-1">
        <div className="flex w-full justify-between">
          <h2 className="flex items-center gap-2 heading-3">
            {t('products:product_other')}
            {isDefined(shareUrl) && (
              <ShareButton
                tooltipText={t('products:copy_shareable_link')}
                shareURL={shareUrl}
                message={t('products:share_button_message')}
              />
            )}
          </h2>
          {isMobile && (
            <Button disabled={isLoading} variant="solid" size="medium" color="secondary" onClick={onFiltersOpen} icon={FiltersIcon}>
              {t('common:filter_one')}
            </Button>
          )}
        </div>
        {!isMobile ?
          <AppliedFilters filters={filters} attributes={attributes} isCollapsible onFilterChange={onFilterChange} isLoading={isLoading} />
        : children}
      </div>
      {!isMobile && children}
    </div>
  );
};
